import { FilterOption } from './filter-option';
import { CommentDto } from '@app/generated/model';
import _ from 'lodash';

const createFilterFromComment = (comment: CommentDto): FilterOption => {
  return {
    count: 1,
    referenceId: comment.referenceId,
    referenceName: comment.referenceName,
    referenceType: comment.referenceType,
  };
};
export const createFilters = (comments: CommentDto[]): FilterOption[] => {
  // Guard against null/undefined or non-array input
  if (!Array.isArray(comments)) {
    return [];
  }

  const filters: { [key: string]: FilterOption } = {};

  for (const comment of comments) {
    const key = `${comment.referenceType}:${comment.referenceId}`;
    const filter = filters[key];

    if (filter) {
      filter.count += 1;
    } else {
      filters[key] = createFilterFromComment(comment);
    }
  }

  const filterList: FilterOption[] = Object.values(filters);

  return [
    ...filterList.filter((f) => f.referenceType === 'WORK_ORDER'),
    ..._.orderBy(
      filterList.filter((f) => f.referenceType !== 'WORK_ORDER'),
      ['referenceType'],
      ['asc'],
    ),
  ];
};
